/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForVmware extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForVmware");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForVmware.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForVmware>): ServiceAccountNativeDetailsForVmware {
        let obj = Object.assign(new ServiceAccountNativeDetailsForVmware(), model);
        ServiceAccountNativeDetailsForVmware.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForVmware>): ServiceAccountNativeDetailsForVmware {
        if (!model) return null;
        return ServiceAccountNativeDetailsForVmware.newInstance(<ServiceAccountNativeDetailsForVmware> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForVmware) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForVmware.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForVmware): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForVmware.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
